import DiningCard from './DiningCard';

interface DiningOption {
  name: string;
  cuisine: string;
  distance: string;
  priceRange: string;
  rating: number;
  image: string;
  alt: string;
  specialties: string[];
  ambiance: string;
}

interface DiningSectionProps {
  className?: string;
}

const DiningSection = ({ className = '' }: DiningSectionProps) => {
  const diningOptions: DiningOption[] = [
  {
    name: 'Single Teas',
    cuisine: 'Bistro - Cafe',
    distance: '0 km',
    priceRange: '₹ - ₹₹',
    rating: 4.7,
    image: "/assets/images/Single_Teas1-1782630222315.jpg",
    alt: 'Single Teas bistro cafe interior',
    specialties: ['Chilli Chicken', 'Nawabi Biryani', 'Ginger Tea', 'Samosas'],
    ambiance: 'A cozy café with vibrant energy.'
  },
  {
    name: 'Chavadi',
    cuisine: 'Native Community Cafe',
    distance: '160 mtrs',
    priceRange: '₹₹ - ₹₹₹',
    rating: 4.1,
    image: "/assets/images/Chavadi-1782634077882.webp",
    alt: 'Chavadi rooftop bar and restaurant with charming ambiance',
    specialties: ['Wood-fired Pizza', 'Prawn Tempura', 'Appam', 'Naan'],
    ambiance: 'A charming roof top bar and restaurant'
  },
  {
    name: 'Mykos Craft Kitchen & Bar',
    cuisine: 'Greek, Mediterranean & Continental',
    distance: '1.5 km',
    priceRange: '₹₹₹',
    rating: 4.4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10e8f5cd4-1782747616620.png",
    alt: 'Mykos Craft Kitchen & Bar - Greek themed restaurant with stunning murals and sculptures on Bannerghatta Road Bangalore',
    specialties: ['Mushroom Fatar', 'Edamame Hummus', 'Spanakopita', 'Baklava Cheesecake'],
    ambiance: 'Greek-inspired décor with stunning murals, live music, DJ & rooftop vibes'
  },
  {
    name: 'A2B - Adayar Ananda Bhavan',
    cuisine: 'South Indian, North Indian & Sweets',
    distance: '1.2 km',
    priceRange: '₹₹',
    rating: 4.2,
    image: "/assets/images/a2b_adayar_ananda_bhavan.png",
    alt: 'A2B Adayar Ananda Bhavan restaurant on Bannerghatta Road Bangalore - bright South Indian vegetarian dining with traditional decor and filter coffee',
    specialties: ['Masala Dosa', 'Filter Coffee', 'Mysore Pak', 'Mini Idly'],
    ambiance: 'Spacious, family-friendly pure vegetarian dining with traditional South Indian charm'
  },
  {
    name: 'Nagarjuna Restaurant',
    cuisine: 'Authentic Andhra & South Indian',
    distance: '1.8 km',
    priceRange: '₹₹ - ₹₹₹',
    rating: 4.1,
    image: "/assets/images/Nagarjuna1-1782635636154.webp",
    alt: 'Nagarjuna Restaurant Bannerghatta Road Bangalore - traditional Andhra meals served on banana leaf with rice, pappu, sambar and curries',
    specialties: ['Andhra Meals on Banana Leaf', 'Pappu & Rice', 'Andhra Chicken Fry', 'Mutton Pepper Fry'],
    ambiance: 'Well-lit, spacious family dining with warm traditional Andhra hospitality since 1984'
  },
  {
    name: 'Rameshwaram Cafe',
    cuisine: 'South Indian & Beverages',
    distance: '3.5 km',
    priceRange: '₹₹',
    rating: 4.3,
    image: "/assets/images/Rameshwaram2-1782635365997.webp",
    alt: 'Rameshwaram Cafe JP Nagar Bangalore - iconic South Indian breakfast cafe with steaming idlis, dosas and filter coffee',
    specialties: ['Butter Idli', 'Ghee Podi Dosa', 'Pudi Masala Dosa', 'Filter Coffee'],
    ambiance: 'Bustling, iconic pure-vegetarian breakfast cafe with quick service and authentic South Indian flavours'
  }];


  return (
    <section className={`py-16 lg:py-24 bg-background ${className}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-text-primary mb-4">
            Dining & Culinary Experiences
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            From authentic local flavors to international cuisines, discover over 50 dining destinations within minutes of Proximus. Your culinary adventure awaits.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {diningOptions.map((option, index) =>
          <DiningCard key={index} {...option} />
          )}
        </div>

        <div className="mt-12 text-center">
          <button className="px-8 py-3 bg-accent text-white font-semibold rounded-lg shadow-subtle hover:shadow-elevated hover:bg-accent/90 transition-all duration-300">
            View Complete Dining Guide
          </button>
        </div>
      </div>
    </section>);

};

export default DiningSection;